module.exports = __webpack_public_path__ + "static/media/Variable Rewards.e944da84.jpg";